"use client";
import axios from "axios";
import { useRef, useState } from "react";
import classes from "./NewsLetterCTA.module.css";
import { useAlertContext } from "@/context/alert";
import { identifyUser } from "@/hooks/TrackingFunctions";

const NewsLetterCTA = () => {
  const [info, setInfo] = useState({
    name: "",
    email: "",
  });

  const { SET_ALERT } = useAlertContext();

  const inputRef = useRef();
  const inputOneRef = useRef();

  const formHandler = (e) => {
    setInfo({ ...info, [e.target.name]: e.target.value });
  };

  const submitFormHandler = async (event) => {
    event.preventDefault();

    if (!info?.name?.trim()) {
      return;
    }

    identifyUser(undefined, {
      firstName: info.name ? info.name : "",
      email: info.email,
    });

    await axios
      .post(`${process.env.NEXT_PUBLIC_SERVER_API}/api/other/newsletter`, {
        email: info.email,
      })
      .then((res) => {
        SET_ALERT({
          msg: "Signed up!",
          type: "success",
        });

        if (inputRef.current) {
          inputRef.current.value = "";
        }
        if (inputOneRef.current) {
          inputOneRef.current.value = "";
        }
      })
      .catch((err) => {});
  };

  return (
    <>
      <form className={classes.main} onSubmit={submitFormHandler}>
        <div className={classes.left}>
          <h3 className={classes.text}>Gimme More</h3>
          <p className={classes.mute}>
            Sign up to our monthly Kashew digest to get the latest stories,
            straight to your inbox. No spam, only goodness.
          </p>
        </div>
        <div className={classes.right}>
          <div className={classes.infoBox}>
            <input
              onChange={(e) => formHandler(e)}
              name="name"
              required
              ref={inputRef}
              placeholder={"Enter your name"}
              className={classes.input}
            ></input>
          </div>
          <div className={classes.infoBox}>
            <input
              onChange={(e) => formHandler(e)}
              name="email"
              type="email"
              required
              ref={inputOneRef}
              placeholder={"Enter your email"}
              className={classes.input}
            ></input>
          </div>

          <button className={classes.button3}>Sign Me Up</button>
        </div>
      </form>
    </>
  );
};

export default NewsLetterCTA;
